import { observable } from 'mobx'
import moment from 'moment'

export default class chartStore {
  @observable chartDataAll = []
  @observable chartData = []
  @observable datasetId = ''
  @observable chartType = ''
  @observable cell = []
  @observable checkTask = false
  @observable checkTaskNo = false

  updateChartData(data) {
    this.chartData = data
  }

  updateChartDataAll(dataall, id) {
    this.chartDataAll = dataall
    this.datasetId = id
  }

  updateChartType(type) {
    this.chartType = type
  }

  updateCell(data, yesButton, noButton) {
    this.cell = data
    this.checkTask = yesButton
    this.checkTaskNo = noButton
  }

  addRow() {
    let moments = this.chartDataAll.map(d => moment(new Date(d.date)))
    let maxDate = moment.max(moments)
    if (this.chartType === 'ChartLineBar') {
      this.chartDataAll.unshift({
        date: moment(maxDate)
          .add(1, 'days')
          .format('l'),
        DateM: '',
        Book: '',
        TimeStart: '',
        TimeEnd: '',
        PageStart: '',
        PageEnd: '',
        Duration: '',
        PagesRead: '',
        PagePerMin: '',
        TotalAveragePagePerMin: '',
        DailyAveragePagePerMin: '',
        BookCategory: '',
        TechnicalLevel: '',
        Type: ''
      })
    } else if (this.chartType === 'ChartDailyKPIs') {
      this.chartDataAll.unshift(
        {
          date: moment(maxDate)
            .add(1, 'days')
            .format('l'),
          activity: 'cc',
          hours: '',
          timeStart: '',
          timeEnd: '',
          comment: '',
          status: '2',
          emoji: '',
          productivity: '',
          hide: ''
        },
        {
          date: moment(maxDate)
            .add(1, 'days')
            .format('l'),
          activity: 'interntVideo',
          hours: '',
          timeStart: '',
          timeEnd: '',
          comment: '',
          status: '2',
          emoji: '',
          productivity: '',
          hide: ''
        },
        {
          date: moment(maxDate)
            .add(1, 'days')
            .format('l'),
          activity: 'ww',
          hours: '',
          timeStart: '',
          timeEnd: '',
          comment: '',
          status: '2',
          emoji: '',
          productivity: '',
          hide: ''
        },
        {
          date: moment(maxDate)
            .add(1, 'days')
            .format('l'),
          activity: 'workout',
          hours: '',
          timeStart: '',
          timeEnd: '',
          comment: '',
          status: '2',
          emoji: '',
          productivity: '',
          hide: ''
        },
        {
          date: moment(maxDate)
            .add(1, 'days')
            .format('l'),
          activity: 'read',
          hours: '',
          timeStart: '',
          timeEnd: '',
          comment: '',
          status: '2',
          emoji: '',
          productivity: '',
          hide: ''
        },
        {
          date: moment(maxDate)
            .add(1, 'days')
            .format('l'),
          activity: 'other',
          hours: '',
          timeStart: '',
          timeEnd: '',
          comment: '',
          status: '2',
          emoji: '',
          productivity: '',
          hide: ''
        },
        {
          date: moment(maxDate)
            .add(1, 'days')
            .format('l'),
          activity: 'sleep',
          hours: '',
          timeStart: '',
          timeEnd: '',
          comment: '',
          status: '2',
          emoji: '',
          productivity: '',
          hide: ''
        }
      )
    } else {
      console.log('under construction!')
    }
  }

  addOldRow() {
    let moments = this.chartDataAll.map(d => moment(new Date(d.date)))
    let minDate = moment.min(moments)
    if (this.chartType === 'ChartLineBar') {
      this.chartDataAll.push({
        date: moment(minDate)
          .subtract(1, 'days')
          .format('l'),
        DateM: '',
        Book: '',
        TimeStart: '',
        TimeEnd: '',
        PageStart: '',
        PageEnd: '',
        Duration: '',
        PagesRead: '',
        PagePerMin: '',
        TotalAveragePagePerMin: '',
        DailyAveragePagePerMin: '',
        BookCategory: '',
        TechnicalLevel: '',
        Type: ''
      })
    } else if (this.chartType === 'ChartDailyKPIs') {
      this.chartDataAll.push(
        {
          date: moment(minDate)
            .subtract(1, 'days')
            .format('l'),
          activity: 'cc',
          hours: '',
          timeStart: '',
          timeEnd: '',
          comment: '',
          status: '2',
          emoji: '',
          productivity: '',
          hide: ''
        },
        {
          date: moment(minDate)
            .subtract(1, 'days')
            .format('l'),
          activity: 'interntVideo',
          hours: '',
          timeStart: '',
          timeEnd: '',
          comment: '',
          status: '2',
          emoji: '',
          productivity: '',
          hide: ''
        },
        {
          date: moment(minDate)
            .subtract(1, 'days')
            .format('l'),
          activity: 'ww',
          hours: '',
          timeStart: '',
          timeEnd: '',
          comment: '',
          status: '2',
          emoji: '',
          productivity: '',
          hide: ''
        },
        {
          date: moment(minDate)
            .subtract(1, 'days')
            .format('l'),
          activity: 'workout',
          hours: '',
          timeStart: '',
          timeEnd: '',
          comment: '',
          status: '2',
          emoji: '',
          productivity: '',
          hide: ''
        },
        {
          date: moment(minDate)
            .subtract(1, 'days')
            .format('l'),
          activity: 'read',
          hours: '',
          timeStart: '',
          timeEnd: '',
          comment: '',
          status: '2',
          emoji: '',
          productivity: '',
          hide: ''
        },
        {
          date: moment(minDate)
            .subtract(1, 'days')
            .format('l'),
          activity: 'other',
          hours: '',
          timeStart: '',
          timeEnd: '',
          comment: '',
          status: '2',
          emoji: '',
          productivity: '',
          hide: ''
        },
        {
          date: moment(minDate)
            .subtract(1, 'days')
            .format('l'),
          activity: 'sleep',
          hours: '',
          timeStart: '',
          timeEnd: '',
          comment: '',
          status: '2',
          emoji: '',
          productivity: '',
          hide: ''
        }
      )
    } else {
      console.log('under construction!')
    }
  }
}



// WEBPACK FOOTER //
// ./src/stores/chartStore.js